<script>
    import ModalConfirm from "../components/modalconfirm.svelte";
    import InlineRadio from "../../components/inline-radio.svelte";
    import wrappedFetch from "../../wrappedFetch.js";
    import { createEventDispatcher } from "svelte";
    import { validate } from "../../components/validate-action";

    export let showAddUserModal = false;
    export let schoolId;

    let successMessage = "";
    let isButtonLoading = false;
    let option = "";
    let existingUser = "";
    let username = "";
    
    let user = { contactname: "", contactlastname: "", contactemail: "" };
    let form = null;
    let error = "";
    let dispatch = new createEventDispatcher();
    let usoUserToAdd;
    let usoUserFound;

    const getUsoUser = async () => {
        let isValid = jQuery(form).valid();
        if(!isValid)
        return;
        await wrappedFetch(
            `/api/account/GetPersonDetails?uid=${username}`,
            { method: "post" }
        )
        .then(resp => resp.json())
        .then(result=> {
            usoUserFound = result.find(r=>r.main == true);
            if(!usoUserFound)
                error="Username not found";
            // usoUsers = result;
        })
        .catch();
    };

    const addUserForPermissions = async () => {
        var isValid = jQuery(form).valid();
        if(showUsername && !usoUserToAdd)
        {
            isValid = false;
            error ="Please find/select user to add."
        }
        if (isValid) {
            let data = {
                userName: username,
                firstName: user.contactname,
                lastName: user.contactlastname,
                email: user.contactemail,
                isExistingUser: existingUser == "yes" ? true : false,
                isUso: option == 1 ? true : false,
                permissionSchoolId: parseInt(schoolId),
            };
            isButtonLoading = true;
            let response = await wrappedFetch(
                "/api/account/AddUserPermission",
                {
                    method: "post",
                    body: JSON.stringify(data),
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );
            let result = await response.json();
            if (result.success) {  
               showAddUserModal = false;             
               successMessage = result.message;
               dispatch("userInvited",{"successMessage":successMessage}); 
            } else {
                error = result.message;
            }
            isButtonLoading = false;
        }
    };

    let showForm = false;
    let showUsername = false;
    $: {
        showForm =
            option != "" &&
            ((option == 1 && existingUser == "no") || option != 1);
        showUsername = option == 1 && existingUser == "yes";
    }
</script>

<ModalConfirm
    showModal={showAddUserModal}
    buttonClass="btn-primary"
    showCancel={true}   
    buttonText={'Add'}
    targetClass="confirm-options"
    bind:isButtonLoading
    on:close={() => (showAddUserModal = false)}
    on:confirm={() => addUserForPermissions()}>
    <div slot="header">
        <h4 class="title">Add users not in the list</h4>
    </div>
    <form
        bind:this={form}
        slot="content"
        use:validate={{ rules: { accountType: { required: true }, user: { required: true } } }}>
        <p>
            Please complete the below to add someone as a Nimbus admin that is
            not currently in your school’s users list. If they do not have an
            existing account they will be sent an email that will allow them to
            create one.
        </p>
        <hr />
        <div class="form-group">
            <div>
                <label style="display:block;">Account type</label>
                <InlineRadio
                    name="accountType"
                    options={[{ label: 'USO', value: 1 }, { label: 'Google/Microsoft', value: 2 }]}
                    bind:value={option} />
            </div>
            <label for="accountType" class="text-danger" style="display:none" />
        </div>

        {#if option == 1}
            <div class="form-group" id="uso-content">
                <div>
                    <label style="display:block;">Is this an existing user or a
                        new one?</label>
                    <InlineRadio
                        name="user"
                        options={[{ label: 'Existing User', value: 'yes' }, { label: 'New User', value: 'no' }]}
                        bind:value={existingUser} />
                </div>
                <label for="user" class="text-danger" style="display:none" />
            </div>
        {/if}
        {#if showUsername}
            <div class="form-group">
                <div class="row">
                    <div class="col-md-4">
                        <label>Username</label><br />                        
                        <input
                            type="text"
                            class="form-control mb-2"
                            bind:value={username}
                            required />     
                    </div>
                    <div class="col-md-4" style="margin-top:27px;">  <button
                        type="button"                           
                      class="btn btn-grey"          
                      on:click={()=> getUsoUser()}>  
                      Find User
                </button>   </div>
                </div>
            </div>
            {#if usoUserFound}
            <div class="form-group">
                <label>Please select user to add</label><br>
                <InlineRadio
                name="user2"
                options={[{ label: `${usoUserFound.firstName} ${usoUserFound.lastName} (${usoUserFound.estab})`, value: 1 }]}
                bind:value={usoUserToAdd} />
            </div>
            {/if}
        {/if}
        {#if showForm}
            <div class="form-group" id="other-account-content">
                <div class="row">
                    <div class="col-md-4">
                        <label>First name</label><br />
                        <input
                            type="text"
                            class="form-control"
                            bind:value={user.contactname}
                            required
                            name="firstname" />
                    </div>
                    <div class="col-md-4">
                        <label>Last name</label><br />
                        <input
                            type="text"
                            class="form-control"
                            bind:value={user.contactlastname}
                            required
                            name="surname" />
                    </div>

                    <div class="col-md-4">
                        <label>Email address</label><br />
                        <input
                            type="email"
                            class="form-control"
                            bind:value={user.contactemail}
                            required
                            name="emailAddress" />
                    </div>
                </div>
            </div>
        {/if}
        {#if error != ''}
            <div class="form-group">
                <p class="text-danger" style="margin-bottom: 0px;">
                    {@html error}
                </p>
            </div>
        {/if}
    </form>
</ModalConfirm>

